/**
 * @file useApplicationLink.ts
 *
 * @fileoverview Provides logic to create the application link based on the application workflow of the job.
 */

import { Job } from '~/jobiqo/types/types';

/*
 * Returns the application link.
 *
 * Depending on the application workflow of the job this hook returns the needed application link.
 */
export const useApplicationLink = (job: Job): string => {
  // Pass the params from the external redirect to the apply page for tracking.
  let params = '';
  if (typeof window !== 'undefined') {
    params = window.location.search;
  }

  const applicationLink =
    job.applicationWorkflow === 'internal'
      ? `/job/apply/${job.id}${params}`
      : job.applicationLink
      ? job.applicationLink
      : // Fallback if no external application link was set.
        `/job/apply/${job.id}${params}`;
  return applicationLink;
};
